import { getExperienceInitCookie } from '../../common/utils/experienceInitCookie';
import { apiUrls } from '../../constants';
import axios from '../../common/utils/interceptor';

export const getAssessmentSupportedOnDesktop = async (): Promise<boolean> => {
  try {
    const experienceProps = getExperienceInitCookie();

    const { data } = await axios.get(apiUrls.APP_COMBINAION_OF_DESKTOP_PLUS_MOBILE_OR_MOBILEAPP, {
      params: {
        projectId: experienceProps?.projectId,
      },
    });
    return data.desktopOnly;
  } catch (e) {
    console.error(`Error in fetching the assessment details`, e);
    return false;
  }
};
